import { __rest, __awaiter, __asyncValues, __asyncGenerator, __await } from '../node_modules/tslib/tslib.es6.js';
import { isObject } from '@websolutespa/bom-core';
import { v4 } from 'uuid';
import { isChunkString, isChunkText } from '../types.js';
import { getMockPrompt, getMockChunks } from './mock.js';

class MessageDecoder {
  set lastUnparsedText(lastUnparsedText) {
    // console.log('MessageService.lastUnparsedText.set', lastUnparsedText);
    this.lastUnparsedText_ = lastUnparsedText;
  }
  get lastUnparsedText() {
    return this.lastUnparsedText_;
  }
  constructor() {
    this.decoder_ = new TextDecoder('utf-8');
    this.lastUnparsedText_ = '';
  }
  bytesToChunks(byteArray) {
    let chunks = [];
    let text = '';
    try {
      text = this.decoder_.decode(byteArray);
      chunks = this.textToChunks(text);
    } catch (error) {
      console.log('decodedChunk.error', error, text);
    }
    // console.log(chunks, text);
    return chunks;
  }
  textToChunks(text) {
    let chunks = [];
    let jsonText = '';
    try {
      if (text.match(/(",|},|],)$/)) {
        let textToReplace = this.lastUnparsedText + text;
        if (textToReplace.match(/^(,)/)) {
          console.log('textToChunks.error', `incorrect line starting [${text}]`);
          textToReplace = textToReplace.substring(1);
        }
        const replacedText = textToReplace.replace(/(,$)/, '');
        jsonText = `[${replacedText}]`;
        const jsonChunks = JSON.parse(jsonText);
        chunks = jsonChunks;
        this.lastUnparsedText = '';
      } else {
        console.log('textToChunks.error', `incorrect line ending [${text}]`);
        this.lastUnparsedText += text;
      }
    } catch (error) {
      console.log('textToChunks.error', error);
      this.lastUnparsedText += text;
    }
    return chunks;
  }
  decodeChunk(chunk) {
    if (isChunkString(chunk)) {
      return {
        type: 'text',
        text: chunk.content
      };
    } else {
      return chunk;
    }
  }
  decodeMessages(messages) {
    return messages.map(x => {
      if (Array.isArray(x.content)) {
        /*
        if (x.role === 'user') {
          return ({
            ...x,
            chunks: x.content.map(x => this.decodeChunk(x)),
          });
        }
        */
        return Object.assign(Object.assign({}, x), {
          chunks: x.content.map(x => this.decodeChunk(x))
        });
      } else if (x.content.lastIndexOf(',') === x.content.length - 1) {
        this.lastUnparsedText = '';
        const message = Object.assign(Object.assign({}, x), {
          chunks: this.chunksToChunkItems(this.textToChunks(x.content))
        });
        if (message.chunks.length === 0) {
          const chunk = {
            type: 'text',
            text: x.content
          };
          return Object.assign(Object.assign({}, x), {
            chunks: [chunk],
            content: [chunk]
          });
        }
        return message;
      } else {
        const chunk = {
          type: 'text',
          text: x.content
        };
        return Object.assign(Object.assign({}, x), {
          chunks: [chunk],
          content: [chunk]
        });
      }
    });
  }
  chunksToResponse(chunks) {
    const response = {
      chunks: [],
      threadId: '',
      messageId: ''
    };
    response.chunks = this.chunksToChunkItems(chunks, response);
    return response;
  }
  logChunks(chunks) {
    chunks.forEach(x => {
      if (isObject(x)) {
        switch (x.type) {
          case 'error':
            console.error('LlmMessageService.error', x);
            break;
          case 'log':
            console.log('LlmMessageService.log', x);
            break;
          case 'header':
            console.log('LlmMessageService.header', x);
            break;
          case 'info':
            console.log('LlmMessageService.info', x);
            break;
          case 'end':
            console.log('LlmMessageService.end', x);
            break;
        }
      }
    });
  }
  chunksToChunkItems(chunks, response) {
    const chunkItems = [];
    chunks.forEach(x => {
      let lastMessage = chunkItems[chunkItems.length - 1];
      if (isObject(x)) {
        switch (x.type) {
          case 'log':
            break;
          case 'error':
            chunkItems.push(x);
            break;
          case 'header':
            {
              const rest = __rest(x, ["type"]);
              if (response) {
                Object.assign(response, rest);
              }
              // console.log('header', response);
            }
            break;
          case 'info':
            {
              if (response) {
                // !!! deprecated
                response.threadId = x.threadId || response.threadId;
              }
            }
            break;
          case 'end':
            break;
          case 'action':
          case 'actionItem':
            if (lastMessage && lastMessage.type === 'actionGroup') {
              lastMessage.items.push(x);
            } else {
              chunkItems.push({
                type: 'actionGroup',
                items: [x]
              });
            }
            break;
          case 'cardItem':
            if (lastMessage && lastMessage.type === 'cardGroup') {
              lastMessage.items.push(x);
            } else {
              chunkItems.push({
                type: 'cardGroup',
                items: [x]
              });
            }
            break;
          case 'productItem':
            if (lastMessage && lastMessage.type === 'productGroup') {
              lastMessage.items.push(x);
            } else {
              chunkItems.push({
                type: 'productGroup',
                items: [x]
              });
            }
            break;
          case 'eventItem':
            if (lastMessage && lastMessage.type === 'eventGroup') {
              lastMessage.items.push(x);
            } else {
              chunkItems.push({
                type: 'eventGroup',
                items: [x]
              });
            }
            break;
          case 'poiItem':
            if (lastMessage && lastMessage.type === 'poiGroup') {
              lastMessage.items.push(x);
            } else {
              chunkItems.push({
                type: 'poiGroup',
                items: [x]
              });
            }
            break;
          case 'tripadvisor':
          case 'tripadvisorItem':
            if (lastMessage && lastMessage.type === 'tripadvisorGroup') {
              lastMessage.items.push(Object.assign(Object.assign({}, x), {
                type: 'tripadvisorItem'
              }));
            } else {
              chunkItems.push({
                type: 'tripadvisorGroup',
                items: [Object.assign(Object.assign({}, x), {
                  type: 'tripadvisorItem'
                })]
              });
            }
            break;
          default:
            if (typeof x.type === 'string' && x.type.match(/Item$/)) {
              const baseName = x.type.replace('Item', '');
              const groupName = `${baseName}Group`;
              if (lastMessage && lastMessage.type === groupName) {
                lastMessage.items.push(x);
              } else {
                chunkItems.push({
                  type: groupName,
                  items: [Object.assign(Object.assign({}, x), {
                    type: baseName
                  })]
                });
              }
            } else {
              chunkItems.push(x);
            }
        }
      } else if (typeof x === 'string') {
        // console.warn('chunksToChunkItems typeof string');
        if (!lastMessage) {
          lastMessage = {
            type: 'text',
            text: ''
          };
          chunkItems.push(lastMessage);
        }
        if (isChunkText(lastMessage)) {
          const lastChunkText = lastMessage;
          if (chunkItems.indexOf(lastChunkText) > 0) {
            // secondary chunk
            lastChunkText.text += x;
          } else if (!lastChunkText.text.includes('\n')) {
            // uncompleted first chunk
            if (x.includes('\n')) {
              const lines = x.split('\n');
              lines.forEach((line, i) => {
                const lastChar = lines.length > i + 1 ? '\n' : '';
                if (i === 0) {
                  lastChunkText.text += line + lastChar;
                } else if (line.length > 0) {
                  chunkItems.push({
                    type: 'text',
                    text: line + lastChar
                  });
                }
              });
            } else {
              // uncompleted first chunk
              lastChunkText.text += x;
            }
          } else {
            // completed first chunk
            chunkItems.push({
              type: 'text',
              text: x
            });
          }
        } else {
          // new text chunk
          chunkItems.push({
            type: 'text',
            text: x
          });
        }
      }
    });
    return chunkItems;
  }
  /*
  chunksToChunkItems___(chunks: LlmChunk[], response?: StreamResponse): LlmChunkItem[] {
    const chunkItems: LlmChunkItem[] = [];
    chunks.forEach(x => {
      const chunk: LlmChunkItem = typeof x === 'string' ? { type: 'text', text: x } : x;
      const lastMessage = chunkItems[chunkItems.length - 1];
      switch (chunk.type) {
        case 'text':
          if (lastMessage && isChunkText(lastMessage)) {
            const text = chunk.text;
            const lastChunkText = lastMessage;
            if (chunkItems.indexOf(lastChunkText) > 0) {
              // secondary chunk
              lastChunkText.text += text;
            } else if (!lastChunkText.text.includes('\n')) {
              // uncompleted first chunk
              if (text.includes('\n')) {
                const lines = text.split('\n');
                lines.forEach((line, i) => {
                  const lastChar = (lines.length > i + 1) ? '\n' : '';
                  if (i === 0) {
                    lastChunkText.text += line + lastChar;
                  } else if (line.length > 0) {
                    chunkItems.push({
                      type: 'text',
                      text: line + lastChar,
                    });
                  }
                });
              } else {
                // uncompleted first chunk
                lastChunkText.text += text;
              }
            } else {
              // completed first chunk
              chunkItems.push(chunk);
            }
          } else {
            // new text chunk
            chunkItems.push(chunk);
          }
          break;
        case 'log':
          break;
        case 'error':
          chunkItems.push(chunk);
          break;
        case 'header': {
          const { type, ...rest } = chunk;
          if (response) {
            Object.assign(response, rest);
          }
          // console.log('header', response);
        }
          break;
        case 'info': {
          if (response) {
            // !!! deprecated
            response.threadId = chunk.threadId || response.threadId;
          }
        }
          break;
        case 'end':
          break;
        case 'action':
        case 'actionItem':
          if (lastMessage && lastMessage.type === 'actionGroup') {
            lastMessage.items.push(chunk);
          } else {
            chunkItems.push({
              type: 'actionGroup',
              items: [chunk],
            });
          }
          break;
        case 'cardItem':
          if (lastMessage && lastMessage.type === 'cardGroup') {
            lastMessage.items.push(chunk);
          } else {
            chunkItems.push({
              type: 'cardGroup',
              items: [chunk],
            });
          }
          break;
        case 'productItem':
          if (lastMessage && lastMessage.type === 'productGroup') {
            lastMessage.items.push(chunk);
          } else {
            chunkItems.push({
              type: 'productGroup',
              items: [chunk],
            });
          }
          break;
        case 'eventItem':
          if (lastMessage && lastMessage.type === 'eventGroup') {
            lastMessage.items.push(chunk);
          } else {
            chunkItems.push({
              type: 'eventGroup',
              items: [chunk],
            });
          }
          break;
        case 'poiItem':
          if (lastMessage && lastMessage.type === 'poiGroup') {
            lastMessage.items.push(chunk);
          } else {
            chunkItems.push({
              type: 'poiGroup',
              items: [chunk],
            });
          }
          break;
        case 'tripadvisor':
        case 'tripadvisorItem':
          if (lastMessage && lastMessage.type === 'tripadvisorGroup') {
            lastMessage.items.push({
              ...chunk,
              type: 'tripadvisorItem',
            });
          } else {
            chunkItems.push({
              type: 'tripadvisorGroup',
              items: [{
                ...chunk,
                type: 'tripadvisorItem',
              }],
            });
          }
          break;
        default:
          if (
            typeof chunk.type === 'string' &&
            chunk.type.match(/Item$/)
          ) {
            const baseName = chunk.type.replace('Item', '');
            const groupName = `${baseName}Group`;
            if (lastMessage && lastMessage.type === groupName) {
              (lastMessage as { items: (typeof x)[] }).items.push(x);
            } else {
              chunkItems.push({
                type: groupName,
                items: [{
                  ...chunk,
                  type: baseName,
                }],
              } as unknown as LlmChunkUnknownItem);
            }
          } else {
            chunkItems.push(chunk);
          }
      }
    });
    return chunkItems;
  }
  */
  static decodeThread(thread) {
    // console.log('thread', thread);
    const decoder = new MessageDecoder();
    return thread ? {
      messages: decoder.decodeMessages(thread.messages),
      threadId: thread.threadId
    } : undefined;
  }
}
class MessageService extends MessageDecoder {
  constructor(options) {
    super();
    this.options = options;
  }
  get origin() {
    return this.options.endpoint || window.location.origin;
  }
  get locale() {
    return this.options.locale || '';
  }
  get url() {
    return `${this.origin}/api/llm/message?locale=${this.locale}`;
  }
  get appKey() {
    return this.options.appKey || '';
  }
  get apiKey() {
    return this.options.apiKey || '';
  }
  get test() {
    return this.options.test || false;
  }
  addUserMessage(messages, prompt, uploaded) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.test) {
        prompt = getMockPrompt(messages.length, this.locale, this.test) || prompt;
      }
      if (uploaded) {
        const chunkItems = [{
          type: 'text',
          text: prompt
        }, {
          type: uploaded.type,
          url: uploaded.url
        }];
        const userMessage = {
          chunks: chunkItems,
          content: chunkItems,
          role: 'user'
        };
        return [...messages, userMessage];
      } else {
        const userMessage = {
          chunks: [{
            type: 'text',
            text: prompt
          }],
          content: prompt,
          role: 'user'
        };
        return [...messages, userMessage];
      }
    });
  }
  getRequest(messages, state) {
    return __awaiter(this, void 0, void 0, function* () {
      return {
        appKey: this.appKey,
        apiKey: this.apiKey,
        messages: messages.filter(x => {
          const chunks = x.chunks.filter(x => typeof x.type === 'string' && !['header', 'info', 'end', 'formRequest', 'formRecap', 'formRecapSuccess', 'formRecapError'].includes(x.type));
          return chunks.length > 0;
        }).map(x => ({
          role: x.role,
          content: x.content
        })),
        threadId: state.threadId,
        systemContext: state.systemContext
      };
    });
  }
  sendMessage(request, onMessage, onEnd, onChunk) {
    return __awaiter(this, void 0, void 0, function* () {
      var _a, e_1, _b, _c;
      if (this.test) {
        return this.mockMessage(request, onMessage, onEnd, onChunk);
      }
      this.abort();
      // console.log('MessageServiceService.request', request);
      const aborter = new AbortController();
      const decodedChunks = [];
      this.lastMessage_ = {
        aborter,
        decodedChunks,
        onEnd
      };
      const signal = aborter.signal;
      const url = this.url;
      let bytes = 0;
      try {
        const response = yield fetch(url, {
          method: 'POST',
          body: JSON.stringify(request),
          headers: {
            'Content-Type': 'application/json'
          },
          signal
        });
        if (response.body) {
          // console.log('headers', Object.fromEntries(response.headers));
          const threadId = response.headers.get('x-thread-id') || '';
          const messageId = response.headers.get('x-msg-id') || '';
          const header = {
            type: 'header',
            threadId,
            messageId
          };
          const headerChunks = [header];
          this.logChunks(headerChunks);
          decodedChunks.push(...headerChunks);
          if (typeof onChunk === 'function') {
            onChunk(headerChunks);
          }
          const reader = response.body.getReader();
          this.lastMessage_.reader = reader;
          this.lastUnparsedText = '';
          try {
            // console.log('lastUnparsedText.clear');
            for (var _d = true, _e = __asyncValues(readChunks(reader)), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
              _c = _f.value;
              _d = false;
              const chunk = _c;
              if (!signal.aborted) {
                bytes += chunk.length;
                const chunks = this.bytesToChunks(chunk);
                this.logChunks(chunks);
                decodedChunks.push(...chunks);
                const response = this.chunksToResponse(decodedChunks);
                if (typeof onMessage === 'function') {
                  onMessage(response);
                }
                if (typeof onChunk === 'function') {
                  onChunk(chunks);
                }
              }
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          if (!signal.aborted) {
            if (typeof onEnd === 'function') {
              const response = this.chunksToResponse(decodedChunks);
              onEnd(response);
            }
          }
        }
      } catch (error) {
        console.warn('MessageService.sendMessage.error', error);
        if (error === 'cancel') {
          if (typeof onEnd === 'function') {
            const response = this.chunksToResponse(decodedChunks);
            response.threadId = response.threadId || request.threadId || 'unknownThreadId';
            onEnd(response);
          }
          return;
        }
        let errorMessage = typeof error === 'string' ? error : JSON.stringify(error, null, 2);
        if (error instanceof TypeError) {
          errorMessage = 'TypeError: Browser may not support async iteration';
        }
        if (typeof onEnd === 'function') {
          const errorChunk = {
            type: 'error',
            error: errorMessage
          };
          decodedChunks.push(errorChunk);
          const response = this.chunksToResponse(decodedChunks);
          onEnd(response);
        }
        // throw (error);
      }
    });
  }
  mockMessage(request, onMessage, onEnd, onChunk) {
    return __awaiter(this, void 0, void 0, function* () {
      var _a, e_2, _b, _c;
      // console.log('mockMessage', request);
      this.abort();
      const aborter = new AbortController();
      const {
        messages
      } = request;
      if (!messages || messages.length === 0) {
        throw {
          status: 400,
          message: 'Bad Request: messages is missing'
        };
      }
      let threadId = request.threadId;
      // threadId is required when messages.length > 1
      if (!threadId && messages.length > 1) {
        throw {
          status: 400,
          message: 'Bad Request: threadId is missing'
        };
      }
      if (!threadId) {
        threadId = v4();
      }
      const messageId = v4();
      const decodedChunks = [];
      const header = {
        type: 'header',
        threadId,
        messageId
      };
      const headerChunks = [header];
      this.logChunks(headerChunks);
      decodedChunks.push(...headerChunks);
      if (typeof onChunk === 'function') {
        onChunk(headerChunks);
      }
      this.lastMessage_ = {
        aborter,
        decodedChunks,
        onEnd
      };
      let bytes = 0;
      const signal = aborter.signal;
      const chunks = getMockChunks(request.messages.length, this.locale, this.test);
      chunks.unshift({
        type: 'info',
        threadId
      });
      chunks.push({
        type: 'end'
      });
      try {
        let controller_;
        const send = function () {
          return __awaiter(this, void 0, void 0, function* () {
            const encoder = new TextEncoder();
            yield new Promise(x => setTimeout(x, 1000));
            for (const chunk of chunks) {
              if (!signal.aborted) {
                const array = encoder.encode(`${JSON.stringify(chunk)},`);
                controller_.enqueue(array);
                yield new Promise(x => setTimeout(x, typeof chunk === 'string' ? 40 : 500));
              }
            }
            if (!signal.aborted) {
              controller_.close();
            }
          });
        };
        const readableStream = new ReadableStream({
          start(controller) {
            controller_ = controller;
            send();
          },
          pull(controller) {
            // We don't really need a pull in this example
          },
          cancel() {
            aborter.abort;
          }
        });
        const reader = readableStream.getReader();
        this.lastMessage_.reader = reader;
        this.lastUnparsedText = '';
        try {
          // console.log('lastUnparsedText.clear');
          for (var _d = true, _e = __asyncValues(readChunks(reader)), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
            _c = _f.value;
            _d = false;
            const chunk = _c;
            if (!signal.aborted) {
              bytes += chunk.length;
              const chunks = this.bytesToChunks(chunk);
              this.logChunks(chunks);
              decodedChunks.push(...chunks);
              const response = this.chunksToResponse(decodedChunks);
              if (typeof onMessage === 'function') {
                onMessage(response);
              }
              if (typeof onChunk === 'function') {
                onChunk(chunks);
              }
            }
          }
        } catch (e_2_1) {
          e_2 = {
            error: e_2_1
          };
        } finally {
          try {
            if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
        if (!signal.aborted) {
          if (typeof onEnd === 'function') {
            const response = this.chunksToResponse(decodedChunks);
            onEnd(response);
          }
        }
      } catch (error) {
        console.error('MessageService.mockMessage.error', error);
        let errorMessage = typeof error === 'string' ? error : JSON.stringify(error, null, 2);
        if (error instanceof TypeError) {
          errorMessage = 'TypeError: Browser may not support async iteration';
        }
        if (typeof onEnd === 'function') {
          const errorChunk = {
            type: 'error',
            error: errorMessage
          };
          decodedChunks.push(errorChunk);
          const response = this.chunksToResponse(decodedChunks);
          onEnd(response);
        }
        // throw (error);
      }
    });
  }
  abort() {
    const lastMessage = this.lastMessage_;
    if (lastMessage && lastMessage.aborter && !lastMessage.aborter.signal.aborted) {
      try {
        if (lastMessage.reader) {
          lastMessage.reader.cancel().catch(error => {
            console.log('MessageService.abort.reader.error', error);
          });
        }
        lastMessage.aborter.abort('cancel');
      } catch (error) {
        console.log('MessageService.abort.error', error);
      }
      if (typeof lastMessage.onEnd === 'function') {
        const response = this.chunksToResponse(lastMessage.decodedChunks);
        lastMessage.onEnd(response);
      }
    }
  }
  shouldAddFormRequest(messages) {
    const isTestThread = this.test && getMockPrompt(messages.length, this.locale, this.test) !== undefined;
    const hasFormRequest = messages.find(x => x.chunks.find(x => x.type === 'formRequest') !== undefined);
    const importantMessages = messages.filter(x => x.chunks.find(x => {
      const has = typeof x.type === 'string' && ['event', 'eventItem', 'eventGroup', 'poi', 'poiItem', 'poiGroup', 'tripadvisor', 'tripadvisorItem', 'tripadvisorGroup'].includes(x.type);
      return has;
    }));
    return !isTestThread && !hasFormRequest && importantMessages.length > 1;
  }
}
function readChunks(reader) {
  return {
    [Symbol.asyncIterator]() {
      return __asyncGenerator(this, arguments, function* _a() {
        let readResult = yield __await(reader.read());
        while (!readResult.done) {
          yield yield __await(readResult.value);
          readResult = yield __await(reader.read());
        }
      });
    }
  };
}
/*
async function* streamAsyncIterable<T>(stream: ReadableStream<T>) {
  const reader = stream.getReader();
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) return;
      yield value;
    }
  } finally {
    reader.releaseLock();
  }
}

class Iterator {
}

(Iterator as any).prototype[Symbol.asyncIterator] = async function* () {
  const reader = this.getReader();
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) return;
      yield value;
    }
  }
  finally {
    reader.releaseLock();
  }
};
*/

export { MessageDecoder, MessageService };
//# sourceMappingURL=message.service.js.map
